import React, { useEffect, useState, useRef } from 'react'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'
import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import ArraySelect from '../Select/ArraySelect'
import { useObserver } from 'mobx-react'
import { emptyGuid, isEmptyGuid } from '../../utils/emptyGuid'
import { t } from 'i18next'

const StyledWrapper = styled.div`


  .form-group {
    padding-left:20px;

    @media screen and (min-width: 460px) {
      width: auto;
    }
  }
`

const StorehouseFilter = ({ storehouseFilter, setStorehouseFilter, showIsVirtual=true }) => {
  const [storehouses, setStorehouses] = useState([])
  //const [filterIsVirtual] = useState(showIsVirtual)
  let storehouseId = useObserver(() => storehouseFilter?.storehouseId || emptyGuid)
  const mountedRef = useRef(true)

  useEffect(() => {
    apiClient.getJson(APIEndpoints.storehouses()).then(resp => {
      if (!mountedRef.current) return null
      setStorehouses(showIsVirtual ? resp.filter(item => item.isVirtual) : resp)
    })
    return () => {
      mountedRef.current = false
    }
  }, [showIsVirtual])

  const updateStorehouseFilter = (displayName, storehouseId = emptyGuid) => {
    let newObj = {
      displayName,
      storehouseId,
    }
    setStorehouseFilter(newObj)
  }

  const handleChange = e => {
    let newStorehouseId = e.target.value

    if (!isEmptyGuid(newStorehouseId)) {
        const storehouseDisplayName = storehouses.find((obj) => obj.id === newStorehouseId).displayName
        updateStorehouseFilter(storehouseDisplayName, newStorehouseId)
    }
    else {
        updateStorehouseFilter(null)
    }
  }

  return (
    <StyledWrapper>
      <div>
        <Form.Group className="mb-3">
          <ArraySelect
            options={storehouses}
            value={storehouseId}
            onChange={handleChange}
            defaultOption={{ value: emptyGuid, name: t('employeesPage:filterNotSelected') }}
            returnEvent
          />
        </Form.Group>
      </div>
    </StyledWrapper>
  )
}

export default StorehouseFilter